import { LOAD_TERMS, LOAD_ERROR } from './types'

// Initial state
const state = {
  filters: {},
  blocks: [],
  error: null,
}

const mutations = {
  [LOAD_TERMS] (state, { data }) {
    state.filters = data
    state.error = null
  },
  [LOAD_ERROR] (state, error) {
    state.error = error
  }
}

import * as getters from './getters'
import * as actions from './actions'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
